export default {
	alternative: "Alternativa",
	alternatives_justification: "Alternativa con justificación",
	alternatives: "Alternativas",
	answer: "Responder",
	answers: "Respuestas",
	basic_data: "Datos básicos",
	clients: "Clientes",
	dissertative: "Disertante",
	end_date: "Fecha final",
	justification: "Justificación",
	justify: "Justificar",
	mandatory: "Obligatório",
	multiple_choices_justification: "Múltiples opciones com justificación",
	multiple_choices: "Múltiples opciones",
	no_questions_are_defined: "Las preguntas no fueron definidas",
	no_survey_avaliable: "No hay encuesta disponible",
	optional: "Opcional",
	owners: "Responsable",
	permission: "Permisos",
	permissions: "Permisos",
	question_save_error: "Error al salvar una pregunta",
	question_save_success: "Pregunta salva con éxito",
	question_type: "Tipo de pregunta",
	question: "Pregunta",
	questions_quantity: "Cantidad de preguntas",
	questions: "Preguntas",
	score: "Puntos",
	select_at_least_one_option: "Seleccionar al menos una opción",
	start_date: "Fecha de inicio",
	survey_published_success: "Búsqueda publicada con éxito",
	survey_save_error: "Error al grabar la búsqueda",
	survey_save_success: "Búsqueda grabada con éxito",
	survey_type: "Tipo de búsqueda",
	survey_unpublished_success: "Búsqueda despublicada con éxito",
	survey_people_answered_quantity: "Cantidad de personas que respondieron",
	survey_people_answered_percentage: "Respuestas (%)",
	surveys: "Búsquedas",
	user_answers: "Respuestas del usuario",
	survey_anonymous_results_label: "Esta encuesta es anónima."
}
